import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';

export class IndustryHierarchyItemBase  {
  id: string;
  name: string;

  json(): any {
    return this;
  }
  loadFromJson(data) {
    this.id = data.id;
    this.name = data.name;
  }
}


